import { useConstant } from './useConstant';
import { generateId } from './generateId';
/**
 * Hook that generates a steady unique id
 */
export function useId(prefix: string = ''): string {
  const id = useConstant(() => generateId(prefix));
  return id;
}
